import {useCallback, useState} from "react";
import {Avatar, Box, Button, Field, Flex, Group, Heading, Input, InputGroup, Stack} from "@chakra-ui/react";
import {userApi} from "../../api/user-api";
import {useToast} from "@chakra-ui/toast";
import {useNavigate} from "react-router-dom";
import {useRecoilState} from "recoil";
import {showTfaCheck, useCleanData, userData, userLoginResultData} from "../../components/hooks/recoilData";
import {handleKeyPress} from "../../components/hooks/HandleKeyPress";

interface AuthToken {
    username: string,
    password: string,
}

const authTokenDefault = (): AuthToken => ({
    username: "",
    password: "",
});

export default function LoginForm(props: {
    pageState: number,
    setPageState: React.Dispatch<React.SetStateAction<number>>
}) {
    const [inputAuthToken, setInputAuthToken] = useState<AuthToken>(authTokenDefault());
    const [showPassword, setShowPassword] = useState(false);
    const handleShowClick = () => setShowPassword(!showPassword);
    const toast = useToast();
    const navigate = useNavigate();
    const [, setUserLoginResult] = useRecoilState(userLoginResultData);
    const [, setUser] = useRecoilState(userData);
    const [, setTfa] = useRecoilState(showTfaCheck);
    const [cleanData] = useCleanData();
    const [loading, setLoading] = useState(false);

    const login = useCallback(() => {
        userApi.login(inputAuthToken.username, inputAuthToken.password)
            .then((o) => {
                setTfa(false);
                setLoading(false);
                o.isExecutor = o.roles && o.roles.includes("EXECUTOR");
                o.isOperator = o.roles && o.roles.includes("OPERATOR");
                o.isEmployer = o.roles && o.roles.includes("EMPLOYER");
                setUserLoginResult(o);
                userApi.userOwnGet()
                    .then((u) => {
                        toast({title: "Logged in", status: "success"});
                        setUser(u);
                        navigate("/lk");
                    })
                    .catch((err) => {
                        console.log("error status code is: " + err);
                        toast({
                            title: "Something when wrong.",
                            description: `code: [${err}]`,
                            status: "error"
                        });
                        cleanData();
                    });
            })
            .catch((err) => {
                setTfa(false);
                setLoading(false);
                console.log("Login error status code is: " + err);
                toast({
                    title: "Login error",
                    description: `code: [${err}]`,
                    status: "error"
                });
                cleanData();
            });
        setTfa(true);
        setLoading(true);
    }, [inputAuthToken, toast, navigate, setUser, setTfa, cleanData, setUserLoginResult]);

    return (
        <Flex flexDirection="column" width="100wh" height="100vh" backgroundColor="gray.200" justifyContent="center" alignItems="center">
            <Stack flexDir="column" mb="2" justifyContent="center" alignItems="center">
                <Avatar.Root>
                    <Avatar.Fallback name="Segun Adebayo"/>
                    {/*<Avatar.Image src="teal.500"/>*/}
                </Avatar.Root>
                <Heading color="teal.400">Вход</Heading>
                <Box minW={{base: "90%", md: "468px"}} onKeyDown={handleKeyPress({Enter: login})}>
                    <Stack gap={4} p="1rem" backgroundColor="whiteAlpha.900" boxShadow="md">
                        <Field.Root>
                            <InputGroup>
                                <Input type="text" placeholder="логин"
                                       value={inputAuthToken.username}
                                       onChange={(it) => setInputAuthToken((prevState) => {
                                           return {...prevState, username: it.target.value}
                                       })}/>
                            </InputGroup>
                        </Field.Root>
                        <Field.Root>
                            <Group attached w="full">
                                <Input
                                    type={showPassword ? "text" : "password"}
                                    placeholder="пароль"
                                    value={inputAuthToken.password}
                                    onChange={(it) => setInputAuthToken((prevState) => {
                                        return {...prevState, password: it.target.value}
                                    })}
                                />
                                <Button h="1.75rem" size="sm" onClick={handleShowClick}>
                                    {showPassword ? "Hide" : "Show"}
                                </Button>
                            </Group>
                        </Field.Root>
                        <Button borderRadius={0} type="submit" variant="solid" colorScheme="teal" width="full" loading={loading} onClick={login}>
                            Вход
                        </Button>
                        <Button borderRadius={0} variant="outline" width="full" onClick={e => props.setPageState(1)}>
                            К регистрации
                        </Button>
                        <Button borderRadius={0} variant="outline" width="full" onClick={e => props.setPageState(2)}>
                            Востановить пароль
                        </Button>
                    </Stack>
                </Box>
            </Stack>
        </Flex>
    );
}